import { Component, Input, ViewChild } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DateFilter } from '../../models/date-filter.model';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
    selector: 'spv2-grid-date-filter',
    templateUrl: './grid-date-filter.component.html',
    styleUrls: ['./grid-date-filter.component.scss'],
    standalone: false
})
export class GridDateFilterComponent extends GridFilterBase<DateFilter> {

  dateValue: DateFilter;
  
  @Input() public set value(v : DateFilter) {
    if(!v) this.dateValue = new DateFilter(); 
    else {
      if(v.value) v.value = new Date(v.value);//Parse to date in case value is a string (because of serialization)
      this.dateValue = v;
    }
    super.value = v;
  }
  
  @Input()public set defaultAfterBeforeChoice(defaultChoice : string) {
    if(this.dateValue){
      this.dateValue.condition = defaultChoice ? defaultChoice : "ge";
    }
  }

  @Input() withTime = false;
  @Input() withAfterBeforeChoice = false;
  @Input() withResetButton = false; //doesn't work for the kendo-datetimepicker, no time to implement it now.

  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  ngOnInit() {
    super.ngOnInit();
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  triggerSearch() {
    if(this.dateValue?.value) this.valueChange.emit(this.dateValue);
    else this.valueChange.emit(null);
    this.searchTriggered.emit();
  }

  dateValueCorrection(date: Date) {
    if(!date) {
      this.dateValue.value = null;
      this.triggerSearch();
      return;
    }

    //Setting time to 00 00 00 hours UTC, so no time conversion is done and the date will always be exactly a specific day at midnight
    var tempDate =  new Date(date.getFullYear(), date.getMonth(), date.getDate());
    this.dateValue.value = new Date(tempDate.getTime() - tempDate.getTimezoneOffset() * 60000)
    this.triggerSearch();
  }

  
  showTooltip(e: MouseEvent): void {
    const targetElement = e.target as HTMLElement;

    this.tooltipDir.hide(); //Always hide

    let filledValueRegex = new RegExp("[0-9]+\/[0-9]+\/[0-9]+( [0-9]+:[0-9]+){0,1}");
    if (targetElement.nodeName === 'INPUT' && targetElement.offsetWidth < targetElement.scrollWidth && filledValueRegex.test((<any>targetElement).value)) {
      this.tooltipDir.toggle(targetElement);
    }
  }
}
